// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UqeI3","colBig":"styles_colBig__3Wau0","colSmall":"styles_colSmall__1vkN7"};